// src/Tiptap.jsx
import { useEditor, EditorContent, FloatingMenu, BubbleMenu, EditorProvider, useCurrentEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { useEffect, useState } from 'react';
import { BiBold } from 'react-icons/bi';
import { BiParagraph } from 'react-icons/bi';
import { FaTextHeight } from 'react-icons/fa';
import { MdTextFields } from 'react-icons/md';
import { IoCodeSlash } from 'react-icons/io5';
import { LuUndo2 } from 'react-icons/lu';
import { LuRedo2 } from 'react-icons/lu';
import { ImPageBreak } from 'react-icons/im';

// define your extension array
const extensions = [StarterKit];

const MenuBar = () => {
  const { editor } = useCurrentEditor();

  if (!editor) {
    return null;
  }

  return (
    <section className='grid grid-cols-8 p-2 gap-2 bg-secondary-foreground/20 rounded-lg h-[90%]'>
      <button
        onClick={() => editor.chain().focus().toggleBold().run()}
        disabled={!editor.can().chain().focus().toggleBold().run()}
        className={`flex items-center justify-center ${editor.isActive('bold') ? 'is-active' : ''}`}
      >
        <BiBold />
      </button>
      <button
        onClick={() => editor.chain().focus().setParagraph().run()}
        className={`flex items-center justify-center ${editor.isActive('paragraph') ? 'is-active' : ''}`}
      >
        <BiParagraph />
      </button>
      <button
        onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
        className={`flex items-center justify-center ${editor.isActive('heading', { level: 1 }) ? 'is-active' : ''}`}
      >
        <FaTextHeight />
      </button>

      <button
        onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}
        className={`flex items-center justify-center ${editor.isActive('heading', { level: 3 }) ? 'is-active' : ''}`}
      >
        <MdTextFields />
      </button>

      <button
        onClick={() => editor.chain().focus().toggleCodeBlock().run()}
        className={`flex items-center justify-center ${editor.isActive('codeBlock') ? 'is-active' : ''}`}
      >
        <IoCodeSlash />
      </button>

      <button
        className='flex items-center justify-center'
        onClick={() => editor.chain().focus().setHorizontalRule().run()}
      >
        <ImPageBreak />
      </button>
      <button
        className='flex items-center justify-center'
        onClick={() => editor.chain().focus().undo().run()}
        disabled={!editor.can().chain().focus().undo().run()}
      >
        <LuUndo2 />
      </button>
      <button
        className='flex items-center justify-center'
        onClick={() => editor.chain().focus().redo().run()}
        disabled={!editor.can().chain().focus().redo().run()}
      >
        <LuRedo2 />
      </button>
    </section>
  );
};

const RichEditor = ({ field, form, defaultContent, className, ...props }: any) => {
  const [content, setContent] = useState(defaultContent);
  const editor: any = useEditor({
    extensions,
    content,
    editorProps: {
      attributes: {
        class: 'mojaklasa focus:outline-none',
      },
    },
  });

  useEffect(() => {
    console.log('OVO JE DEFAUTL', defaultContent);
    if (editor) {
      console.log(editor.commands);
      editor.commands.setContent('JEBEM TI SVE');
    }
    // setContent(defaultContent);
  }, [defaultContent, field.value]);

  useEffect(() => {
    console.log(field.value, editor?.value);
    // if (editor) {
    //   editor.commands.setValue('LELELEL');
    // }
    // setContent(field.value);
  }, []);

  useEffect(() => {
    form?.setFieldValue(field.name, content);
  }, [content]);

  return (
    <div className={`rich-editor-container text-white rounded-lg py-2 grid grid-rows-10 ${className}`}>
      <EditorProvider
        extensions={extensions}
        onUpdate={(event: any) => {
          setContent(event.editor.getHTML());
        }}
        content={content}
        slotBefore={
          <div className='row-span-1'>
            <MenuBar />
          </div>
        }
      >
        <></>
      </EditorProvider>
      <FloatingMenu editor={editor}>This is the floating menu</FloatingMenu>
      <BubbleMenu editor={editor}>This is the bubble menu</BubbleMenu>
    </div>
  );
};

export default RichEditor;
// .rich-editor-container div:nth-child(2)
